// --- src/constants/colors.ts ---
// Default color values for white-label UI
// These are used as fallback when company has no custom branding

export const DEFAULT_COLORS = {
  primary_color: '#2563eb', // blue-600
  secondary_color: '#1e293b', // slate-800
  accent_color: '#f59e0b', // amber-500
  // Régi mezők (backward compatibility)
  background_color: '#f8fafc', // slate-50
  card_background: '#1f2937', // gray-800
  // Új dark mode mezők
  background_color_light: '#f8fafc', // slate-50
  background_color_dark: '#0f172a', // slate-900
  card_background_light: '#ffffff', // white
  card_background_dark: '#1f2937', // gray-800
} as const;
